import React from "react";
import ReactDOM from "react-dom";
import { findEducationRequest } from "../../infrastructure/repository/request-repository";
import { addContextLog } from "../../infrastructure/log";
import RequestEducationTable from "./components/RequestEducationTable";
import { findCompanyId } from "../../infrastructure/repository/company-repository";

export function renderRequestEducationTable(props) {
  const target = document.getElementById("table-request-education-container");

  if (target) {
    ReactDOM.render(<RequestEducationTable {...props} />, target);
  }
}

export async function displayRequestEducationTable(
  { requests, isLoading } = {
    requests: [],
    isLoading: true,
  }
) {
  const companyId = await findCompanyId();
  const { data: educationRequests } = await findEducationRequest({ companyId });
  if (requests.length === 0) {
    requests = educationRequests;
    isLoading = false;
  }
  addContextLog("info", "displayRequestEducationTable", "display-screen", {
    requests,
  });

  const props = {
    requests,
    isLoading,
  };

  renderRequestEducationTable(props);
}
